import React, { useEffect, useState } from 'react';
import '../ImagePrompt.css';
import './CarruselPrompt.css';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import ButtonSidebar from '../ButtonSidebar/ButtonSidebar';
import { Prompt, useHistory } from 'react-router-dom';
import arrowSVG from '../Iconos/arrow.svg';
import playSVG from '../Iconos/play.svg';
import checkSVG from '../Iconos/check.svg';
import exampleImage1 from '../Imagenes/ejemplo1.png';
import exampleImage2 from '../Imagenes/ejemplo2.png';
import exampleImage3 from '../Imagenes/ejemplo3.png';
import exampleImage4 from '../Imagenes/ejemplo4.png';
import ImagePreviewCarousel from './ImagePreviewCarousel';
import { Helmet } from 'react-helmet';

const VALID_MINUTES = 35; // Images are saved for 35 minutes
const MAX_IMAGES = 8; // Maximum number of images allowed in the carousel

function CarouselPrompt() {
  const history = useHistory();
  const { t } = useTranslation();
  const [prompt, setPrompt] = useState('');
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [thumbnails, setThumbnails] = useState<string[]>([]);
  const [isGenerating, setIsGenerating] = useState(false);
  const [selectedImages, setSelectedImages] = useState<string[]>([]);
  const [progress, setProgress] = useState(0); // Estado para el progreso del "progress bar"
  const DescribeImage = t('DescribeImage');
  const userId = localStorage.getItem('userId') || 'defaultUserId';
  const [isProcessStarted, setIsProcessStarted] = useState(false); // Controla si el proceso ha comenzado

  // Usar el hook de navegación para manejar los avisos

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsGenerating(true);
    setIsProcessStarted(true); // Marcar que el proceso ha comenzado al hacer clic en "Crear"

    try {
      const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001';
      const response = await axios.post(`${backendUrl}/generate-image`, { prompt });
      if (response.data.images && response.data.images.length) {
        const imageData = {
          timestamp: new Date().getTime(),
          images: response.data.images,
        };
        localStorage.setItem('imageData', JSON.stringify(imageData));
        setThumbnails(response.data.images);
        setSelectedImageIndex(0);
        
        await actualizarCreditos();

      } else {
        console.error("No images returned from the API");
      }
    } catch (error) {
      console.error("Error generating image:", error);
    } finally {
      setIsGenerating(false);
    }
  };
  useEffect(() => {
    const promptDataJSON = localStorage.getItem('promptData');
    if (promptDataJSON) {
      const promptData = JSON.parse(promptDataJSON);
      const timeNow = new Date().getTime();
      const timeElapsed = (timeNow - promptData.timestamp) / 1000 / 60; // Time in minutes

      if (timeElapsed < VALID_MINUTES) {
        setPrompt(promptData.prompt);
      } else {
        localStorage.removeItem('promptData'); // Prompt expired
      }
    }

    const selectedImagesJSON = localStorage.getItem('selectedImages');
    if (selectedImagesJSON) {
      const imageData = JSON.parse(selectedImagesJSON);
      const timeNow = new Date().getTime();
      const timeElapsed = (timeNow - imageData.timestamp) / 1000 / 60; // Tiempo en minutos

      if (timeElapsed < VALID_MINUTES && imageData.images) {
        setSelectedImages(imageData.images);
      } else {
        localStorage.removeItem('selectedImages'); // Imágenes caducadas
      }
    }
  }, []);

  const handlePromptChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newPrompt = e.target.value;
    setPrompt(newPrompt);
    const promptData = {
      timestamp: new Date().getTime(),
      prompt: newPrompt,
    };
    localStorage.setItem('promptData', JSON.stringify(promptData));
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const newImageUrl = URL.createObjectURL(file);
      addImageToCarousel(newImageUrl);
    }
  };

  useEffect(() => {
    // Verificar si el usuario está autenticado
    const userId = localStorage.getItem('userId');
    if (!userId) {
      // Redirigir a la página de inicio de sesión si no está autenticado
      history.push('/PantallaInicial');
    }
  }, [history]);

  const addImageToCarousel = (imageUrl: string) => {
    if (selectedImages.length < MAX_IMAGES) {
      if (!selectedImages.includes(imageUrl)) {  // Verificar si la imagen ya existe
        const newSelectedImages = [...selectedImages, imageUrl];
        setSelectedImages(newSelectedImages);
        const selectedImagesData = {
          timestamp: new Date().getTime(),
          images: newSelectedImages,
        };
        localStorage.setItem('selectedImages', JSON.stringify(selectedImagesData));
      } else {
        alert("La imagen ya está en el carrusel.");  // Mensaje opcional
      }
    } else {
      alert(`No se pueden agregar más de ${MAX_IMAGES} imágenes.`);
    }
  };


  const removeImageFromCarousel = (imageIndex: number) => {
    const newSelectedImages = selectedImages.filter((_, index) => index !== imageIndex);
    setSelectedImages(newSelectedImages);
    const selectedImagesData = {
      timestamp: new Date().getTime(),
      images: newSelectedImages,
    };
    localStorage.setItem('selectedImages', JSON.stringify(selectedImagesData));
  };



  useEffect(() => {
    setThumbnails([exampleImage1, exampleImage2, exampleImage3, exampleImage4]);
    setSelectedImageIndex(0);
  }, []);

  useEffect(() => {
    if (isGenerating) {
      const interval = setInterval(() => {
        setProgress((prevProgress) => {
          if (prevProgress >= 100) {
            clearInterval(interval);
            return 100;
          }
          return prevProgress + 1.67; // Incremento del progreso para completar en 60 segundos (100 / 60 ≈ 1.67)
        });
      }, 1000); // Actualizar cada segundo
    }
  }, [isGenerating]);

  const handleSelectImage = () => {
    if (thumbnails.length > 0 && selectedImageIndex < thumbnails.length) {
      const selectedImage = thumbnails[selectedImageIndex];
      addImageToCarousel(selectedImage);
    }
  };


  useEffect(() => {
    const imageDataJSON = localStorage.getItem('imageData');
    if (imageDataJSON) {
      try {
        const imageData = JSON.parse(imageDataJSON);
        const timeNow = new Date().getTime();
        const timeElapsed = (timeNow - imageData.timestamp) / 1000 / 60; // Time in minutes

        if (timeElapsed < VALID_MINUTES && imageData.images) {
          setThumbnails(imageData.images);
          setSelectedImageIndex(0);
        } else {
          localStorage.removeItem('imageData'); // Images expired
        }
      } catch (error) {
        console.error('Error parsing imageData from localStorage:', error);
      }
    }
  }, []);
  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      if (isProcessStarted) {
        event.preventDefault();
        event.returnValue = ''; // Muestra un mensaje en el cuadro de diálogo del navegador
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [isProcessStarted]);

  const confirmNavigation = (nextPath: string) => {
    if (isProcessStarted) {
      const confirmed = window.confirm(t('¿Estás seguro que quieres salir? Ya se han descontado créditos.'));
      if (confirmed) {
        history.push(nextPath);
      }
    } else {
      history.push(nextPath);
    }
  };
  const actualizarCreditos = async () => {
    try {
      const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001';
      const response = await axios.get(`${backendUrl}/creditos`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });
      const datosCreditos = response.data;
      // Aquí podrías llamar a setCreditosRestantes o hacer algo con los datos
      console.log('Créditos actualizados:', datosCreditos.creditosRestantes);
      // Aquí debes actualizar el estado en el componente que los muestra
    } catch (error) {
      console.error('Error al actualizar los créditos:', error);
    }
  };
  
  const handlePreviousImage = () => {
    if (selectedImageIndex > 0) {
      setSelectedImageIndex(selectedImageIndex - 1);
    }
  };

  const handleNextImage = () => {
    if (thumbnails.length > 0 && selectedImageIndex < thumbnails.length - 1) {
      setSelectedImageIndex(selectedImageIndex + 1);
    }
  };

  const handlePreviousPage = () => {
    history.push('/');
  };

  const handleNextPage = () => {
    history.push('/Social-Networking-Carousel2');
  };

  const moveImage = (index: number, direction: 'up' | 'down') => {
    if (selectedImages.length > 0 && index >= 0 && index < selectedImages.length) {
      const newSelectedImages = [...selectedImages];
      const [removed] = newSelectedImages.splice(index, 1);
      const newIndex = direction === 'up' ? index - 1 : index + 1;
      newSelectedImages.splice(newIndex, 0, removed);
      setSelectedImages(newSelectedImages);
      const selectedImagesData = {
        timestamp: new Date().getTime(),
        images: newSelectedImages,
      };
      localStorage.setItem('selectedImages', JSON.stringify(selectedImagesData));
    }
  };

  const handleMoveUp = (index: number) => {
    if (index > 0) {
      moveImage(index, 'up');
    }
  };

  const handleMoveDown = (index: number) => {
    if (index < selectedImages.length - 1) {
      moveImage(index, 'down');
    }
  };

  const handleSaveDraft = async (imageUrl: string) => {
    const token = localStorage.getItem('token'); // Assuming you save the token in localStorage
    if (!token) {
      alert('No estás autenticado.');
      return;
    }

    try {
      const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001'; // En desarrollo puedes usar localhost por defecto

      console.log(backendUrl);

      const response = await axios.post(`${backendUrl}/save-drafts`, {
        userId,
        images: [imageUrl]
      }, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      alert('Borrador guardado con éxito');
    } catch (error) {
      console.error('Error al guardar el borrador:', error);
      alert('Error al guardar el borrador');
    }
  };

  return (
    <div className='container-text'>
      <Helmet>
        <title>Redes Sociales - Carrusel</title>
      </Helmet>
      <Prompt
        when={isProcessStarted}
        message="¿Estás seguro de que quieres salir? Se han descontado créditos por este proceso."
      />

      <div className='img-container'>
        <div className="thumbnails-container">
          <ImagePreviewCarousel
            thumbnails={selectedImages}
            onSelect={handleSelectImage}
            onRemove={removeImageFromCarousel}
            onMoveUp={handleMoveUp}
            onMoveDown={handleMoveDown}
          />
        </div>
        <div className="image-prompt-container">
          <div className="image-gallery-container"></div>
          <div className="image-prompt-title">
            <p>{t('imagePrompt.describeYourImage')} <span className="highlight">{t('imagePrompt.ImageHere')}</span>.</p>
          </div>
          <div className="image-prompt-description">
            <form onSubmit={handleSubmit}>
              <input
                className='input-prompt'
                value={prompt}
                onChange={handlePromptChange}
                placeholder={DescribeImage}
              ></input>
              <button className="image-prompt-button" type="submit">
                <span className="image-prompt-button-icon"><img src={playSVG} alt="" /> </span>
                {t('imagePrompt.create')}
              </button>
            </form>
          </div>
          <div className="file-upload-container">
            <input
              type="file"
              id="file-upload"
              accept="image/*"
              onChange={handleFileChange}
              className="file-upload-input"
              style={{ display: 'none' }}
            />
            <label htmlFor="file-upload" className="file-upload-label">
              <span>Subir foto</span>
            </label>
          </div>

          {isGenerating && (
            <div className="loading-container">
              <div className="loading-indicator">{t('Generando')}...</div>
              <div className="progress-bar">
                <div className="progress-bar-fill" style={{ width: `${progress}%` }}></div>
              </div>
            </div>
          )}
          <div className="main-image-container">
            <div className="main-image-container-distribution">
              {thumbnails.length > 0 && (
                <>
                  <button className="image-nav-left" onClick={handlePreviousImage}>
                    <img src={arrowSVG} alt="Previous" className='reverse-arrow' />
                  </button>
                  <img src={thumbnails[selectedImageIndex]} alt="Selected" className="main-image" />
                  <button className="image-nav-right" onClick={handleNextImage}>
                    <img src={arrowSVG} alt="Next" className='normal-arrow' />
                  </button>
                </>
              )}
            </div>
            <div className="image-indicators">
              {thumbnails.map((_, index) => (
                <div
                  key={index}
                  className={`image-indicator ${index === selectedImageIndex ? 'active' : ''}`}
                  onClick={() => setSelectedImageIndex(index)}
                />
              ))}
            </div>
            <button className="select-button" onClick={handleSelectImage}>
              <div className='text-prompt-image'>
                <div className='text-prompt-icon'><img src={checkSVG} alt="" /> </div>
                <div>{t('Seleccionar')}</div>
              </div>
            </button>
            <div className="image-selection-navigation">
              <button className="image-selection-previous" onClick={handlePreviousPage}>
                <img src={arrowSVG} alt="" className='reverse-arrow' /> {t('Anterior')}
              </button>
              <button className="image-selection-next" onClick={handleNextPage}>
                {t('Siguiente')} <img src={arrowSVG} alt="" className='normal-arrow' />
              </button>
            </div>
          </div>
        </div>
      </div>
      <ButtonSidebar
        selectedImage={thumbnails[selectedImageIndex]}
        onSaveDraft={handleSaveDraft}
        onCropClick={function (): void {
          throw new Error('Function not implemented.');
        }}
      />
    </div>
  );
}

export default CarouselPrompt;


